import { API_BASE_URL } from "../../config"
import request from "../../utilities/request"

const registerAllHolders = () => request.post(`${API_BASE_URL}/blockchain/registerAll`)

export default registerAllHolders